import React from "react";
import { PropTypes } from "prop-types";
import {
    HomeEmptyState,
    HomeSearchResultGridCell,
    HomeOrderBySelect,
    HomeListSearchLoader,
    HomeListLoader,
} from "application/home/components";
import { MrbGrid } from "mrb/components/grid";
import { observer } from "mobx-react";
import { MrbContentLoader } from "mrb/components/loader";
import { MrbPager } from "mrb";
import { PremiumBadge, Image } from "common/components";
import { isNil, map } from "lodash";
import { nakiRadioContentType, useCanAccessContent } from "application/common/content-access";

function CategorySearchResultsTemplate({ categoryGenericSearchViewStore, t }) {
    const { gridStore, orderBySelectStore, queryUtility } = categoryGenericSearchViewStore;

    return (
        <React.Fragment>
            <MrbContentLoader loaderStore={gridStore.loaderStore} loaderRender={() => <HomeListLoader row={1} title />}>
                {() => (
                    <div>
                        <AppearsInList categoryGenericSearchViewStore={categoryGenericSearchViewStore} t={t} />
                    </div>
                )}
            </MrbContentLoader>
            {gridStore.hasItems && (
                <div className="c-home__filter">
                    <div className="c-home__filter__wrapper">
                        <p className="u-type--base u-type--wgt--bold">Search results</p>

                        <div className="c-home__filter__select">
                            <HomeOrderBySelect store={orderBySelectStore} t={t} />
                        </div>
                    </div>
                </div>
            )}

            <MrbGrid
                store={gridStore}
                t={t}
                classNameOverride="c-home__list--search"
                loaderRender={() => <HomeListSearchLoader row={8} />}
                cellRender={(props) => <HomeSearchResultGridCell {...props} />}
                emptyStateRender={() => <HomeEmptyState classNameExtend="c-empty-state--no-results--lrg" t={t} />}
                pagerRender={(props) => (
                    <MrbPager {...props} hideItemsPerPage={true} hidePagerIfUnderLimit={queryUtility.filter.pageSize} />
                )}
            />
        </React.Fragment>
    );
}

CategorySearchResultsTemplate.propTypes = {
    categoryGenericSearchViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

const AppearsInList = observer(function PodcastGroupsList({ categoryGenericSearchViewStore, t }) {
    const {
        appearsInData,
        onClickPodcastGroup,
        onClickArtist,
        scrollFeaturedLeft,
        scrollFeaturedRight,
        isAppearsInScrollable,
        setAppearsInContainerRef,
    } = categoryGenericSearchViewStore;
    return (
        <React.Fragment>
            {appearsInData.length > 0 && (
                <div>
                    <div className="c-home__list__header">
                        <div className="u-type--base u-type--wgt--bold u-mar--bottom--tny">
                            {t("APPLICATION.HOME.LIST.GENERIC_SEARCH.APPEARS_IN")}
                        </div>
                        {isAppearsInScrollable && (
                            <div className="u-display--flex">
                                <i
                                    className="u-icon u-icon--base u-icon--arrow-left u-mar--right--tny"
                                    onClick={scrollFeaturedLeft}
                                />
                                <i className="u-icon u-icon--base u-icon--arrow-right" onClick={scrollFeaturedRight} />
                            </div>
                        )}
                    </div>

                    <div className="u-animation--fadeIn">
                        <div className="c-home__list--scroll" ref={setAppearsInContainerRef}>
                            {map(appearsInData, (item) =>
                                !isNil(item.podcastId) ? (
                                    <PodcastGroup
                                        item={item}
                                        key={item.podcastId}
                                        onClickPodcastGroup={onClickPodcastGroup}
                                    />
                                ) : (
                                    <Artist item={item} key={item.artistId} onClickArtist={onClickArtist} />
                                )
                            )}
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
});

function PodcastGroup({ item, onClickPodcastGroup }) {
    const contentAccessResult = useCanAccessContent(nakiRadioContentType.podcast, {
        isPremium: item.isParentPodcastPremium,
    });
    return (
        <div className="c-home__card" onClick={() => onClickPodcastGroup(item)}>
            <div className="c-home__card__media">
                <div className="c-home__card__img-wrapper">
                    <Image src={item.coverImageUrl} />
                    <PremiumBadge
                        isPremium={item.isParentPodcastPremium}
                        isPremiumSubscriptionValid={contentAccessResult.canAccessPremium}
                    />
                </div>
            </div>
            <div className="c-home__card__title">{item.title}</div>
        </div>
    );
}

function Artist({ item, onClickArtist }) {
    const canAccessContent = useCanAccessContent(nakiRadioContentType.nakiNigun, {
        isPremium: item.isPremium,
    });
    return (
        <div className="c-home__card" onClick={() => onClickArtist(item)}>
            <div className="c-home__card__media">
                <div className="c-home__card__img-wrapper">
                    <Image src={item.coverImageUrl} />
                    <PremiumBadge isPremium={item.isArtistPremium} isPremiumSubscriptionValid={canAccessContent} />
                </div>
            </div>
            <div className="c-home__card__title">{item.name}</div>
        </div>
    );
}

export default observer(CategorySearchResultsTemplate);
